import React from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import "./report.css"; // Custom CSS file for styling

const Chart = (props) => {
    const data = {
        labels:  props?.data?.labels,
        datasets: [
          {
            data: props?.data?.data,
            backgroundColor: ['rgba(255, 184, 0, 1)', 'rgba(216, 0, 0, 1)', '#0ebd0e', 'rgba(60, 228, 225, 1)', 'rgba(94, 149, 151, 1)'],
            hoverBackgroundColor: ['rgba(255, 184, 0, 1)', 'rgba(216, 0, 0, 1)', '#0ebd0e', 'rgba(60, 228, 225, 1)', 'rgba(94, 149, 151, 1)'],
          },
        ],
    }
  const options = {
    cutout: "0%", // Inner radius for the donut
    plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
          position: 'right',
        },
        datalabels: {
          formatter: (value, context) => {
            return `${value}%`;
          },
          color: '#FFF',
          font: {
            weight: 'bold',
          },
        },
      },
  };

  return (
    <div className="ncr-tracker">
      {/* <h3>NCR Tracker</h3> */}
      <div className="chart-container">
        <Doughnut data={data} options={options} />
        <div className="chart-center">
          {/* <span className="total-count">17</span><br/>
          <span className="total-label">Total Ncr</span> */}
        </div>
      </div>
      {props?.data?.labels?.map(val=>{
        return<>
        <div className="chart-legend">
        <div className="legend-item">
          <div className="legend-color closed" style={{backgroundColor:val=="In Progress"?"rgba(255, 184, 0, 1)":
            val=="Completed"?"#0ebd0e":val=="On Hold"?"rgba(60, 228, 225, 1)":val=="Overdue"?""
            :"rgba(216, 0, 0, 1)"}}>

            </div>
          <span>{val}</span>
        </div>
      </div>
        </>
      })}
     
    </div>
  );
};

export default Chart; 